<template>
  <div class="d-flex flex-column">
    <div v-if="isVisible" class="question-element">
      <div class="item-pane" :class="{ 'no-border': noBorder }">
        <div v-if="hideIconBox" class="question-box">
          <div class="box-number">
            <div v-if="hasIcon">
              <i :class="icon" />
            </div>
            <div
              v-else
              :id="
                `${id}-qn${
                  subNumber == undefined ? displayNumberText : displayNumber
                }`
              "
            >
              {{ subNumber == undefined ? displayNumberText : displayNumber }}
              <sup class="question-number-sup">{{ subNumber }}</sup>
              <span class="d-none question-title">Pregunta</span>
            </div>
          </div>
        </div>

        <div class="question-box-content">
          <div class="question-line col">
            <p
              class="mb-0 p-2 pl-4"
              :class="{ 'border-bottom': hasFields, 'bold-text': boldText }"
              v-html="text"
            />
            <Error
              v-if="hasAnError || hasAWarning || hasAFieldError"
              :is-alert-mode="hasAWarning"
              :message="validationMessage"
            />
            <div class="col-8 mw-100">
              <Error
                v-if="
                  !hasAnError &&
                    !hasAWarning &&
                    !hasAFieldError &&
                    hasAttachedWarning
                "
                :is-alert-mode="hasAttachedWarning"
                :message="warningMessage"
              />
            </div>
            <!-- TextArea -->
            <div v-if="isTextArea" class="question-textarea">
              <textarea
                :id="`${id}-txtQuestionOpenAnswer`"
                v-model="questionOpenAnswer"
                class="form-control textarea"
                name=""
                cols="30"
                rows="5"
                maxlength="3000"
                :disabled="isDisabled"
              />
              <span>3,000 caracteres</span>
            </div>

            <slot name="children" />

            <div v-if="showCommentsBox">
              <label v-if="isYesNoAnswer">Explique:</label>
              <textarea
                :id="`${id}-txtQuestionOpenAnswerExp`"
                v-model="questionOpenAnswer"
                class="form-control textarea"
                name=""
                cols="30"
                rows="5"
                maxlength="3000"
                :disabled="isDisabled"
              />
            </div>

            <!-- END TextArea -->

            <div v-if="hasFields" class="col pl-0">
              <div
                v-if="isVisibleFieldCaption"
                class="mt-2 mb-2 p-2 pl-4 question-field-title"
                v-html="fieldCaption"
              />
              <div class="row p-2 pl-4 question-field-content">
                <div class="col-12">
                  <div class="row">
                    <div
                      v-for="(field, index) in questionFields"
                      v-show="
                        field.visible ||
                          (field.visible == null &&
                            (field.showWithValue == null ||
                              field.showWithValue == selectedAnswer ||
                              (field.listValuesForShow != null &&
                                field.listValuesForShow.some(
                                  (item) => item === selectedAnswer
                                ))))
                      "
                      :key="index"
                      :class="field.class"
                    >
                      <div>
                        <div
                          v-show="field.label != null && !isCommentMode"
                          class="field-label"
                        >
                          <p
                            :id="`${id}-p${field.id}-${index}`"
                            v-html="field.label"
                          />
                        </div>
                        <custom-drop-down
                          v-if="field.type == 'dropdown'"
                          :id="`${id}-${field.id}-${index}`"
                          :ref="`question_field_${field.id}`"
                          v-model="field.value"
                          :options="field.options"
                          :fieldkey="field.fieldkey"
                          :fieldname="field.fieldname"
                          :placeholder="field.placeholder"
                          :error="field.error"
                          :disabled="field.disabled || isDisabled"
                          :custom-error-msg="field.customErrorMsg"
                          @input="onFieldChange($event, field)"
                        />

                        <custom-date-picker
                          v-if="field.type == 'date'"
                          :id="`${id}-${field.id}-${index}`"
                          :ref="`question_field_${field.id}`"
                          v-model="field.value"
                          :placeholder="field.placeholder"
                          :max-date="field.maxDate"
                          :disabled="field.disabled || isDisabled"
                        />

                        <custom-file-input
                          v-if="field.type == 'file'"
                          :id="`${id}-${field.id}-${index}`"
                          :ref="`question_field_${field.id}`"
                          v-model="field.value"
                          :name="field.name"
                          :accept="'.pdf'"
                          :disabled="field.disabled || isDisabled"
                          :attachment-id="field.attachmentId"
                          :attachment-status="field.attachmentStatus"
                          :canReplace="field.canReplace"
                          @replace="
                            $emit('replace-file', {
                              questionNumber: number,
                              file: $event,
                            })
                          "
                        />

                        <div
                          v-if="field.type == 'textarea'"
                          class="comment-text-area"
                        >
                          <custom-text-area
                            v-show="true"
                            :id="`${id}-${field.id}-${index}`"
                            :ref="`question_field_${field.id}`"
                            v-model="field.value"
                            :maxlength="field.maxChars"
                            :placeholder="field.placeholder"
                            :classes="['eq-field']"
                            :count-classes="['text-secondary']"
                            :disabled="field.disabled || isDisabled"
                          />
                        </div>
                        <div
                          v-if="field.type == 'multiple-selection-options'"
                          class="mt-2"
                        >
                          <div
                            v-for="(option, index) in field.options"
                            :key="`chk${field.id}${option.Value}_${index}`"
                            class="custom-control custom-checkbox mr-sm-2"
                          >
                            <input
                              :id="
                                `chkWizardQuestion${number}${field.id}${index}`
                              "
                              :ref="`question_field_${field.id}`"
                              v-model="field.selectedOptions"
                              type="checkbox"
                              class="custom-control-input"
                              :value="option.Value"
                              :disabled="field.disabled || isDisabled"
                              @change="onChangeCheckbox($event, field)"
                            />
                            <label
                              :id="
                                `lblWizardQuestion${number}${field.id}${index}`
                              "
                              :for="
                                `chkWizardQuestion${number}${field.id}${index}`
                              "
                              class="custom-control-label font"
                            >
                              {{ option.Display }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <span
                v-if="hasAFieldError || hasAFieldWarning"
                :class="{
                  'error-val': hasAFieldError,
                  'warning-val': hasAFieldWarning,
                }"
              >
                <i class="fa fa-times-circle" aria-hidden="true" />
                <span class="ml-1" v-html="validationMessage" />
              </span>
            </div>
          </div>

          <!-- RadioButtons -->
          <div
            v-if="
              !isCommentMode &&
                (isYesNoAnswer ||
                  isConditionalMultipleSelection ||
                  isYesNoNaAnswers)
            "
            class="align-items-end d-flex p-0 custom-radio-container"
          >
            <div
              v-for="index in columnOffset"
              v-show="hasOffsetColumn"
              :key="'bcolumnOffset' + index"
              class="w-49 ml-2"
            />
            <div
              v-for="(item, index) in questionOptions"
              :id="`${id}-rbContainer${number}`"
              :key="index"
              class="text-center rounded-top mb-0 custom-radio-button"
              :class="{
                'bg-green': selectedAnswer == item.Value,
                'bg-red': forceError,
                'bg-gray': !forceError && !(selectedAnswer == item.Value),
              }"
            >
              <div class="radio">
                <label :id="`lbl-radio-${number}-${index}`" class="w-100 mb-0">
                  <input
                    :id="`${id}-rb${number}`"
                    v-model="selectedAnswer"
                    type="radio"
                    :name="`Question${number}YesNoOption`"
                    :value="item.Value"
                    :disabled="isDisabled"
                    @change="onValueChange"
                  />
                  <span
                    :id="`${id}-sp${number}`"
                    class="cr rounded-circle"
                    :class="{ 'cr-error': forceError }"
                  >
                    <i
                      :id="`${id}-i${number}`"
                      class="cr-icon fa fa-check text-white"
                      :class="{ 'show-check': selectedAnswer == item.Value }"
                    />
                  </span>
                </label>
              </div>
              <span
                class="step-label"
                :class="{
                  error: forceError,
                }"
              >
                {{ item.Display }}
              </span>
            </div>
            <div
              v-for="index in columnOffset"
              v-show="!hasOffsetColumn"
              :key="'fcolumnOffset' + index"
              class="w-49"
            />
          </div>
          <!-- END RadioButtons -->

          <!-- Dropdown -->
          <div v-if="isDropDown" class="col-md-4">
            <div class="mt-2">
              {{ dropdownUpperText }}
            </div>
            <select
              :id="`${id}-question-select-${number}`"
              v-model="selectedAnswer"
              class="form-control question-select mt-1"
              :disabled="isDisabled"
              @change="onValueChange($event)"
            >
              <option
                v-for="(option, index) in questionOptions"
                :key="'isDropDown' + index"
                :value="option.Value"
              >
                {{ option.Display }}
              </option>
            </select>
          </div>
          <!-- END Dropdown -->

          <!-- INPUT -->
          <div v-if="isOpenTextBox" class="col-md-2">
            <input
              :id="`${id}-question-input-${number}`"
              v-model="questionOpenAnswer"
              class="form-control question-answer
            mt-3"
              type="text"
              :disabled="isDisabled"
            />
          </div>
          <!-- END INPUT -->

          <div v-if="isDate" class="mt-3">
            <custom-date-picker
              :id="`${id}-question-date-${number}`"
              v-model="selectedAnswer"
              right
              :format="'dd/MMM./yyyy'"
              :disabled="isDisabled"
              @onSelectedDate="onValueChange"
            />
          </div>
        </div>
      </div>
      <!-- PANEL DE INFORMACION -->
      <div v-if="notes && notes.length > 0" class="item-pane-info">
        <div class="row justify-content-md-center">
          <div class="col-12">
            <p
              v-for="(note, index) in notes"
              :key="`info_item_${index}`"
              class="d-flex panel-info-description"
            >
              <i class="far fa-exclamation-circle" />
              <span :id="`spNotes-${index}`" v-html="note.message" />
            </p>
          </div>
        </div>
      </div>
      <!-- FIN PANEL DE INFORMACION -->
    </div>
  </div>
</template>

<script>
// import { forestgreen } from 'color-name';
// import { log } from 'util';
//ECG:Para tipos de seleccion excepcionales se debera crear un tipo de pregunta nuevo? ej. Region-Distrito-Escuela
const answerControlTypes = Object.freeze({
  Dropdown: 0,
  YesNo: 1,
  TextBox: 2,
  TextArea: 3,
  Date: 4,
  ConditionalMultipleSelection: 5,
  MultipleSelection: 6,
  QuestionForm: 7,
  YesNoNa: 8,
});
import yesOrNotEnum from '@/utils/constants/yesOrNotEnum';
// const validationResultTypes = Object.freeze({ Error: 1, Warning: 2 });

import CustomDatePicker from '../../components/common/CustomDatePicker';
import CustomFileInput from '../../components/common/CustomFileInput';
import CustomTextArea from '../../components/common/CustomTextArea';
import CustomDropDown from '../../components/common/CustomDropDown';
import Error from '../../components/common/Error';

const defaultYesNoAnswers = [
  { Display: 'Si', Value: true },
  { Display: 'No', Value: false },
];
export default {
  name: 'WizardQuestion',
  components: {
    CustomDatePicker,
    CustomFileInput,
    CustomTextArea,
    CustomDropDown,
    Error,
  },
  props: {
    id: {
      type: String,
      default: 'wzQuestions',
      meta: {
        description: 'Id del Componente Wizard',
        example: 'wzQuestions',
      },
    },
    defaultOptionValueSelected: {
      type: [Boolean, Number],
      default: 0,
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
      meta: {
        description: 'Parámetro de entrada en el input',
        example: 'Texto requerido',
      },
    },
    number: {
      type: Number,
      default: 0,
    },
    fields: {
      type: Array,
      default: () => new Array(),
    },
    displayNumber: {
      type: String,
      default: '',
    },
    subNumber: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    hasAttachedWarning: {
      type: Boolean,
      default: false,
    },
    warningMessage: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    answerControlType: {
      type: Number,
      default: 0,
    },
    optionListValue: {
      type: Array,
      default: () => new Array(),
    },
    dropdownUpperText: {
      type: String,
      default: '',
    },
    getOptions: { type: [Object, Array, Function], default: () => [] },
    getDefaultValue: { type: Function, default: null },
    onChange: { type: Function, default: null },
    isRequired: Boolean,
    requireErrorCode: { type: String, default: '' },
    requireErrorMessage: { type: String, default: '' },
    validator: { type: Function, default: null },
    pickerMinDate: {
      type: String,
      default: '',
    },
    fieldCaption: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: true,
    },
    selectedOption: {
      type: String,
      default: '',
    },
    showMultipleSelectionOptions: {
      type: Boolean,
      default: false,
    },
    showCommentsBox: {
      type: Boolean,
      default: false,
    },
    initialState: Boolean,
    notes: {
      type: Array,
      default: () => new Array(),
    },
    showWithValue: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: () => false,
    },
    hasIcon: {
      type: Boolean,
      default: () => false,
    },
    icon: {
      type: String,
      default: '',
    },
    hideIconBox: {
      type: Boolean,
      default: () => true,
    },
    columnOffset: {
      type: Number,
      default: 0,
    },
    showFieldCaption: {
      type: Boolean,
      default: true,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    boldText: {
      type: Boolean,
      default: () => false,
    },
    forceError: {
      type: Boolean,
      default: () => false,
    },
    isCommentMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: false,
      isCheckedYesNoOption: false,
      selectedAnswer: null,
      selectedOptions: [],
      questionOpenAnswer: undefined,
      validationResult: {
        isValid: true,
        resultType: 0,
        messageText: '',
        showFieldValidation: false,
      },
      invalidSelection: false,
      validationResultTypes: { Ok: 0, Error: 1, Warning: 2, FancyWarning: 3 },
      options: null,
      multipleSelectionOptions: null,
      validators: [],
      isVisible: true,
      text: '',
      infos: [],
      questionFields: this.fields,
      controlType: null,
      isVisibleFieldCaption: this.showFieldCaption,
    };
  },
  mounted() {
    this.controlType = this.answerControlType;

    this.changeValueFromDefaultValue();

    if (this.visible != null) {
      this.isVisible = this.visible;
    }
    this.text = this.description;
    if (this.options == null) {
      this.refreshOptions();

      if (this.value != null) this.selectedAnswer = this.value;

      //cargando valor por defecto.
      if (this.getDefaultValue != null) {
        this.getDefaultValue().then((defaultValue) => {
          this.selectedAnswer = defaultValue;
          this.$set(this, 'selectedAnswer', defaultValue);
          this.onValueChange();
        });
      }
    }

    if (this.options == null && this.optionListValue != null) {
      this.options = this.optionListValue;
    }

    if (this.isRequired == true) {
      this.validators.push(this.validateRequired);
    }

    if (this.validator != null) {
      this.validators.push(this.validator);
    }

    this.$emit('onMounted', this);
  },
  watch: {
    visible(value) {
      this.isVisible = value;
      this.clear();
    },
    invalidSelection: {
      handler: function() {
        this.$emit('questionChange', this);
      },
      deep: true,
    },
    value(newValue) {
      this.selectedAnswer = newValue;
    },
    defaultOptionValueSelected() {
      this.changeValueFromDefaultValue();
    },
    selectedAnswer: function(newValue, oldValue) {
      if (this.fields != null && oldValue != null) {
        this.fields.forEach((field) => {
          if (
            field.showWithValue == newValue ||
            (field.listValuesForShow != null &&
              field.listValuesForShow.some((item) => item === newValue))
          ) {
            field.value = null;
            if (field.type == 'multiple-selection-options') {
              field.selectedOptions = [];
            }
          }
        });
      }
      this.$emit('input', newValue);
    },
  },
  computed: {
    optionsCountClass() {
      if (this.questionOptions != null)
        return 'col-md-' + (this.questionOptions.length + this.columnOffset);
      return null;
    },
    hasOffsetColumn() {
      return this.questionOptions && this.questionOptions.length > 2;
    },
    hasFields() {
      if (this.questionFields && this.questionFields.length > 0) {
        return this.questionFields.some((field) => {
          let isFieldWithSameSelectedValue =
            field.showWithValue != null &&
            field.showWithValue == this.selectedAnswer;
          return isFieldWithSameSelectedValue || field.showWithValue == null;
        });
      }

      return false;
    },
    hasAnError() {
      return (
        !this.hasAnWarning &&
        (this.invalidSelection ||
          (!this.validationResult.isValid &&
            this.validationResult.resultType ==
              this.validationResultTypes.Error))
      );
    },
    hasAWarning() {
      return (
        this.validationResult.resultType == this.validationResultTypes.Warning
      );
    },
    hasAFieldWarning() {
      return (
        this.validationResult.showFieldValidation &&
        this.validationResult.resultType == this.validationResultTypes.Warning
      );
    },
    hasAFieldError() {
      return (
        this.validationResult.showFieldValidation &&
        !this.validationResult.isValid &&
        this.validationResult.resultType == this.validationResultTypes.Error
      );
    },
    validationMessage() {
      if (this.validationResult.messageText == null) {
        if (this.isYesNoAnswer)
          return 'Pregunta ' + this.number + ': Favor de seleccionar Sí o No.';
      }
      return this.validationResult.messageText;
    },
    displayNumberText: function() {
      if (this.displayNumber == null) {
        let displayNumber = Math.floor(this.number);
        if (this.subNumber) return displayNumber + this.subNumber;
        else return displayNumber;
      }
      if (this.subNumber) return this.displayNumber + this.subNumber;
      return this.displayNumber;
    },
    selectedAnswerId: function() {
      let result = this.options.filter(
        (element) => element.Value == this.selectedAnswer
      );
      if (result.length > 0) {
        return result[0].Id;
      }
      return null;
    },
    selectedAnswerText: function() {
      let result = this.options.filter(
        (element) => element.Value == this.selectedAnswer
      );
      if (result.length > 0) {
        return result[0].Display;
      }
      return null;
    },
    questionOptions: function() {
      if (this.isYesNoAnswer) {
        return defaultYesNoAnswers;
      }
      return this.options;
    },
    isYesNoAnswer: function() {
      return answerControlTypes.YesNo == this.answerControlType;
    },
    isDropDown: function() {
      return answerControlTypes.Dropdown == this.answerControlType;
    },
    isOpenTextBox: function() {
      return answerControlTypes.TextBox == this.answerControlType;
    },
    isTextArea: function() {
      return answerControlTypes.TextArea == this.answerControlType;
    },
    isDate: function() {
      return answerControlTypes.Date == this.answerControlType;
    },
    isConditionalMultipleSelection: function() {
      return (
        answerControlTypes.ConditionalMultipleSelection ==
        this.answerControlType
      );
    },
    isMultipleSelection: function() {
      return answerControlTypes.MultipleSelection == this.answerControlType;
    },
    isYesNoNaAnswers: function() {
      return answerControlTypes.YesNoNa == this.answerControlType;
    },
    isQuestionForm: function() {
      return this.answerControlType == answerControlTypes.QuestionForm;
    },
  },
  methods: {
    onChangeCheckbox(evt, field) {
      if (typeof field.onChange == 'function') {
        field.onChange(evt, field);
      }
    },
    onValueChange() {
      if (this.onChange != null) {
        this.onChange(this);
      }
      if (!this.isDate)
        //fecha es validada en onChange de la pregunta
        this.validate(true);
    },
    changeValueFromDefaultValue() {
      let answer = null;

      if (this.defaultOptionValueSelected > 0 && this.isYesNoAnswer) {
        answer = this.defaultOptionValueSelected === yesOrNotEnum.yes;
      } else if (this.defaultOptionValueSelected > 0) {
        this.selectedAnswer = this.defaultOptionValueSelected;
      }

      if (answer != null && answer > 0) {
        this.selectedAnswer = answer;
        this.$set(this, 'selectedAnswer', this.selectedAnswer);
        this.onValueChange();
      }
    },
    validateRequired: function(question, isOnchangeEvent) {
      if (question != null && !isOnchangeEvent) {
        let hasFields = this.fields != null && this.fields.length > 0;
        let isQuestionForm =
          (this.selectedAnswer != null && hasFields) || this.isQuestionForm;

        if (hasFields && isQuestionForm) {
          let invalidField = this.questionFields.find((field) => {
            let isVisible =
              field.visible ||
              (field.visible == null &&
                (field.showWithValue == null ||
                  field.showWithValue == this.selectedAnswer ||
                  (field.listValuesForShow != null &&
                    field.listValuesForShow.some(
                      (item) => item === this.selectedAnswer
                    ))));
            let isFieldRequired = field.required && isVisible;

            let isMultipleSelectionField =
              field.type == 'multiple-selection-options';
            if (isFieldRequired) {
              if (isMultipleSelectionField) {
                let isInvalidSelection =
                  field.selectedOptions == null ||
                  (field.selectedOptions != null &&
                    field.selectedOptions.length == 0);
                return isInvalidSelection;
              }
              if (field.type == 'file') {
                let fieldElement = this.getFieldElement(field.id);
                let isDeletedAttachment =
                  fieldElement.attachmentId != null &&
                  fieldElement.status == 'deleted';
                let isNotLoadedAttachment =
                  (fieldElement.value == null || fieldElement.value == '') &&
                  fieldElement.attachmentId == null;

                return isNotLoadedAttachment || isDeletedAttachment;
              }

              return field.value == null || field.value == '';
            }
            return false;
          });

          if (invalidField != null) {
            this.validationResult.isValid = false;
            this.validationResult.resultType = this.validationResultTypes.Error;
            if (invalidField.requireErrorMessage != null) {
              this.validationResult.messageText =
                invalidField.requireErrorMessage;
              this.validationResult.showFieldValidation =
                invalidField.showFieldValidation;
            }
            return false;
          }
        }
      }

      if (this.isRequired) {
        if (
          ((this.isDropDown ||
            this.isDate ||
            this.isYesNoAnswer ||
            this.isYesNoNaAnswers) &&
            this.selectedAnswer == null) || //pregutnas si o no, dropdown, fecha
          (this.showCommentsBox &&
            (this.questionOpenAnswer == null ||
              this.questionOpenAnswer == '')) || //comentario en diferentes casos
          (this.isOpenTextBox &&
            (this.questionOpenAnswer == '' ||
              this.questionOpenAnswer == null)) || //input
          ((this.showMultipleSelectionOptions || this.isMultipleSelection) &&
            this.selectedOptions.length == 0) ||
          (this.isTextArea &&
            (this.questionOpenAnswer == null ||
              this.questionOpenAnswer == '')) ||
          (this.isConditionalMultipleSelection &&
            this.selectedAnswer == null &&
            !isOnchangeEvent)
        ) {
          //selección múltipe
          this.validationResult.isValid = false;
          this.validationResult.resultType = this.validationResultTypes.Error;
          if (this.requireErrorMessage != null) {
            this.validationResult.messageText = this.requireErrorMessage;
          }
          return false;
        }
      }
      return true;
    },
    validate(isOnChangeEvent) {
      if (this.isVisible) {
        // si la opción dispara warning
        if (this.invalidSelection && this.validationResult.resultType == 2) {
          return true;
        }

        if (this.invalidSelection) {
          return false;
        }

        //Si la opcion seleccionada no dispara error, entonces ejecuta las demas validaciones.
        if (this.validators.length > 0) {
          let result = true;
          this.validators.forEach((validator) => {
            if (!validator(this, isOnChangeEvent)) {
              result = false;
            }
          });
          this.validationResult.isValid = result;
          if (result) {
            this.validationResult.resultType = this.validationResultTypes.Ok;
            this.validationResult.messageText = '';
          }
        } else {
          this.validateRequired(this, isOnChangeEvent);
        }
        return this.validationResult.isValid;
      }
      return true;
    },
    clear() {
      this.selectedAnswer = undefined;
      this.questionOpenAnswer = '';
      this.selectedOptions = [];
      this.invalidSelection = false;

      let fieldComment = this.getField('comentario');
      if (fieldComment) {
        fieldComment.visible = false;
      }
      this.validationResult.isValid = true;
      this.validationResult.resultType = this.validationResultTypes.Ok;

      if (this.fields != null) {
        this.fields.forEach((field) => {
          field.value = null;
          if (field.type == 'multiple-selection-options') {
            field.selectedOptions = [];
          }
        });
      }
      this.refreshOptions();
    },
    ThrowErrorMessage() {
      this.$parent.$parent.showMessage(
        this.requireErrorMessage,
        'alert-danger'
      );
    },
    CambioStatus() {
      this.$parent.$parent.CambioStatus();
    },
    setVisible(status) {
      this.isVisible = status;
    },
    refreshOptions() {
      //Cargando opciones de pregunta
      if (typeof this.getOptions === 'function') {
        this.getOptions().then((options) => {
          this.options = options;
          this.multipleSelectionOptions = options;
        });
      } else if (
        this.getOptions != null &&
        Array.isArray(this.getOptions.options)
      ) {
        this.options = this.getOptions.options;
        this.multipleSelectionOptions = this.getOptions.options;
      }

      //Actualizando campos
      if (this.fields != null) {
        this.questionFields.forEach((field) => {
          if (field.getOptions != null) {
            field.getOptions().then((options) => {
              field.options = options;
              field.value = null;
            });
          }
        });
      }
    },
    getFieldElement(id) {
      if (this.$refs['question_field_' + id] != null)
        return this.$refs['question_field_' + id][0];
      return null;
    },
    getField(id) {
      if (this.questionFields) {
        return this.questionFields.find((field) => field.id == id);
      }
    },
    onFieldChange(value, field) {
      if (field != null && field.onChange != null) {
        field.onChange(value, this);
      }
    },
  },
};
</script>

<style scoped>
.show-check {
  opacity: 1 !important;
}

.item {
  display: flex;
  justify-content: space-between;
}

.question {
  box-shadow: -3px 1px 3px #00000029;
  align-content: space-between;
}

.item-pane {
  justify-content: space-between;
  min-width: 50%;
  box-shadow: -3px 1px 3px #00000029;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.item-pane.no-border {
  border-bottom: none;
}

.item-pane-info {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 5px 5px;
  margin-bottom: 10px;
  font: 400 14px/17px Lato;
  letter-spacing: 0;
  color: #11291b;
  padding: 20px 10px 10px;
}

.item-pane-info p {
  margin-bottom: 10px;
}

.item-pane-info p i {
  margin-right: 8px;
  font-size: 16px;
}

.question-box {
  width: 65px;
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 22px 12px; */
}

.question-box-content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.box-number {
  font: Bold 32px/19px Lato;
}
.box-label {
  font: 15px Lato;
  display: block;
}
.question-line.pl-55 {
  padding-left: 55px !important;
}
.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.w-49 {
  width: 49%;
}
.w-100 {
  width: 100% !important;
}
.bg-gray {
  background: #f2f2f2;
}
.bg-green {
  background: #2db782;
}
.bg-red {
  background: #ffebeb;
  border: 1px solid #c9545e;
}
/************* end of custom radio *****************/
.checkbox label:after,
.radio label:after {
  content: '';
  display: table;
  clear: both;
}

.checkbox .cr,
.radio .cr {
  position: relative;
  display: inline-block;
  border: 2px solid #a9a9a9;
  border-radius: 0.25em;
  width: 1.2em;
  height: 1.2em;
  margin-top: 4px;
}

.cr {
  border-radius: 50%;
}

.checkbox .cr .cr-icon,
.radio .cr .cr-icon {
  position: absolute;
  font-size: 0.6em;
  line-height: 0;
  top: 55%;
  left: 19%;
}

.cr-icon {
  margin-top: 0.04em;
}

.checkbox label input[type='checkbox'],
.radio label input[type='radio'] {
  display: none;
}

.checkbox label input[type='checkbox'] + .cr > .cr-icon,
.radio label input[type='radio'] + .cr > .cr-icon {
  opacity: 0;
}

.checkbox label input[type='checkbox']:checked + .cr > .cr-icon,
.radio label input[type='radio']:checked + .cr > .cr-icon {
  opacity: 1;
}

.checkbox label input[type='checkbox']:disabled + .cr,
.radio label input[type='radio']:disabled + .cr {
  opacity: 0.5;
}
.rounded-top {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/************* end of custom radio *****************/
label,
p {
  font-weight: normal;
}

.step-label {
  display: block;
  font: Regular 11px/11px Lato;
  font-size: 10px;
  letter-spacing: 0;
  color: #c9c9c9;
}

.bg-green .step-label {
  color: white;
}

.bg-green .radio .w-100 .cr.rounded-circle {
  border: 2px solid white;
  opacity: 1;
}

.cr-error {
  border: 2px solid #c9545e !important;
}

.step-label.active {
  color: #2db782;
  font-weight: bold;
}
.step-label.error {
  color: #c9545e;
}
.error-val {
  color: #ff5b5c;
  display: block;
  padding-left: 25px;
}
.success-val {
  color: #2db782;
  display: block;
}
.warning-val {
  color: #af6708;
  display: block;
}
.question-number-sup {
  font: 21px Lato;
  letter-spacing: 0;
  color: #ffffff;
}
.form-control.textarea {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
}
.custom-control-label.font {
  font: 400 16px/19px Lato;
  color: #11291b;
  padding-top: 4px;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #2db782;
  background-color: #2db782;
}
.custom-red-alert {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #ff5b5c;
  border-radius: 5px;
}
.question-comment {
  background-color: #f2f2f2;
  font-weight: normal;
  text-align: left;
  font: Regular 14px/17px Lato;
  letter-spacing: 0;
  color: #707070;
  opacity: 1;
  padding-left: 2%;
  padding-right: 2%;
  margin-top: 0px;
}

.comment-text-area {
  padding: 20px;
  background: transparent linear-gradient(180deg, #e4e6e2 0%, #f4f6f300 100%) 0%
    0% no-repeat padding-box;
}

.custom-radio-container {
  padding-top: 15px !important;
  margin-right: 42px;
}

.custom-radio-container .custom-radio-button {
  width: 70px;
  margin-right: 8px;
}

.bold-text {
  font-weight: bold;
}
.mw-100 {
  max-width: none;
}
.question-title {
  font-size: 8pt;
  text-align: center;
  font-weight: normal;
}
</style>
